import styled, { injectGlobal, StyledFunction } from 'styled-components'

export const Credits = styled.div`
  position: absolute;
  bottom: 1em;
  right: 1em;

  color: rgba(255, 255, 255, 0.35);
  font-size: 12px;
`

export const Frame = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  background: black;
`

const prompt: StyledFunction<{ isVisible: boolean }> = styled.h1
export const Prompt = prompt`
  position: absolute;
  bottom: 2em;
  left: 50%;
  transform: translateX(-50%);

  transition: opacity 2.5s;
  opacity: ${props => props.isVisible ? 1 : 0};

  color: rgba(255, 255, 255, 0.35);
  font-size: 3rem;
  line-height: 1.25em;
  text-align: center;
`

// tslint:disable-next-line:no-unused-expression
injectGlobal`
* {
  box-sizing: border-box;
}

/* http://meyerweb.com/eric/tools/css/reset/
   v2.0 | 20110126
   License: none (public domain)
*/

html, body, div, span, applet, object, iframe,
h1, h2, h3, h4, h5, h6, p, blockquote, pre,
a, abbr, acronym, address, big, cite, code,
del, dfn, em, img, ins, kbd, q, s, samp,
small, strike, strong, sub, sup, tt, var,
b, u, i, center,
dl, dt, dd, ol, ul, li,
fieldset, form, label, legend,
table, caption, tbody, tfoot, thead, tr, th, td,
article, aside, canvas, details, embed,
figure, figcaption, footer, header, hgroup,
menu, nav, output, ruby, section, summary,
time, mark, audio, video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}
/* HTML5 display-role reset for older browsers */
article, aside, details, figcaption, figure,
footer, header, hgroup, menu, nav, section {
  display: block;
}
body {
  line-height: 1;
}
ol, ul {
  list-style: none;
}
blockquote, q {
  quotes: none;
}
blockquote:before, blockquote:after,
q:before, q:after {
  content: '';
  content: none;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}
`

// tslint:disable-next-line:no-unused-expression
injectGlobal`
  @import url('https://fonts.googleapis.com/css?family=Roboto+Mono');

  body {
    font-family: Roboto Mono, monospace;
    overflow: hidden;
  }
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/styles.ts